export const portfolioPageData = {
  header: {
    title: "Najnowsze oferty",
    subtitle:
      "Ekskluzywne projekty cyfrowe, które\ndefiniują nową jakość branży",
  },
  viewAllText: "Zobacz wszystkie oferty",
};
